module.exports = __webpack_public_path__ + "img/tms-fill.5688e821.svg";